import { render, staticRenderFns } from "./GoodsSearch.vue?vue&type=template&id=c89c486e&scoped=true&"
import script from "./GoodsSearch.vue?vue&type=script&lang=js&"
export * from "./GoodsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89c486e",
  null
  
)

export default component.exports